'use client'

import { useMemo } from 'react'

import { useSettings } from '@core/hooks/useSettings'
import useVerticalNav from '@menu/hooks/useVerticalNav'

const Logo = () => {
  const { isHovered } = useVerticalNav()
  const { settings } = useSettings()

  const { layout } = settings

  const imageFull = useMemo(() => {
    return layout !== 'collapsed' || isHovered
  }, [layout, isHovered])

  return (
    <div className='flex flex-col items-center min-bs-[24px]'>
      {imageFull ? (
        <img src='/images/icon/logo_white.png' alt='logo' width={195} height={80} />
      ) : (
        <img src='/images/icon/logo_m_white.png' alt='logo' width={45} height={45} />
      )}
    </div>
  )
}

export default Logo
